import React, { Component } from 'react'
import { PHOTO_TYPES } from '../../utils'
import { Loading } from '../../misc'
import { formHandler, Button, Select } from '../../ui'
import { getProperty, totalCardSpaceOptions } from '../../utils'

import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import * as gearActions from '../../../actions/gear'

class CameraSelectionForm extends Component {
    constructor(props) {
        super(props)

        this.state = { data: this.props.data }

        this._updateValue = formHandler.updateValue.bind(this)
    }

    componentWillMount() {
        if (! this._getCameraMakes().length) {
            this.props.gearActions.loadCameraMakes(this.props.type)
        }

        if (this.props.data.make) {
            this.props.gearActions.loadCameraModels(this.props.type, this.props.data.make)
        }
    }

    _getCameraMakes() {
        return getProperty(this.props.gear, `camera_makes.${ this.props.type }`, [])
    }

    _getCameraModels() {
        return getProperty(this.props.gear, `camera_models.${ this.props.type }`, [])
    }

    _updateCameraMake = (data) => {
        // when updating the camera make, load in the models associated to that make
        this.props.gearActions.loadCameraModels(this.props.type, data.make)

        // when updating the camera make, invalidate the currently-selected camera model
        data.model = null

        this._updateValue(data)
    }

    _submitCameraData = () => {
        const data = {
            media_type: PHOTO_TYPES[this.props.type],
            make: this.state.data.make,
            model: this.state.data.model,
            total_card_space: this.state.data.total_card_space,
        }

        this.props.gearActions.submitCamera(
            this.props.type,
            data,
            this.props.crew_uuid,
            this.state.data.uuid
        )
    }

    render() {
        if (! this._getCameraMakes().length) {
            return <Loading />
        }

        const errors = this.props.gear.errors

        let modelSelection = null
        let capacitySelection = null

        const makeSelection = (
            <Select
                error={ errors.make }
                name="make"
                options={ this._getCameraMakes() }
                placeholder="Select camera make"
                updateValue={ this._updateCameraMake }
                value={ this.state.data.make }
            />
        )

        if (this.state.data.make && this._getCameraModels().length) {
            modelSelection = (
                <Select
                    error={ errors.model }
                    name="model"
                    options={ this._getCameraModels() }
                    placeholder="Select camera model"
                    updateValue={ this._updateValue }
                    value={ this.state.data.model }
                />
            )
        }

        if (this.state.data.model) {
            capacitySelection = (
                <Select
                    error={ errors.total_card_space }
                    name="total_card_space"
                    options={ totalCardSpaceOptions() }
                    placeholder="Total card space"
                    updateValue={ this._updateValue }
                    value={ this.state.data.total_card_space }
                />
            )
        }

        return (
            <div>
                <p>
                    Don’t see your make and/or model? Email
                    { ' ' }
                    <a href="mailto:gear@hayden5.com">gear@hayden5.com</a>
                    { ' ' }
                    and we can add it to our database.
                </p>

                { makeSelection }
                { modelSelection }
                { capacitySelection }

                <Button
                    buttonOnly
                    loading={ this.props.appState.loading }
                    onClick={ this._submitCameraData }
                    status="primary"
                >
                    Save
                </Button>
            </div>
        )
    }
}

CameraSelectionForm.propTypes = {
    appState: React.PropTypes.object.isRequired,
    crew_uuid: React.PropTypes.string.isRequired,
    data: React.PropTypes.object.isRequired,
    gear: React.PropTypes.object.isRequired,
    gearActions: React.PropTypes.object.isRequired,
    type: React.PropTypes.oneOf([ 'video', 'still' ]).isRequired,
}

export default connect(
    (state) => {
        return {
            appState: state.appState,
            gear: state.gear,
        }
    },
    (dispatch) => {
        return {
            gearActions: bindActionCreators(gearActions, dispatch),
        }
    }
)(CameraSelectionForm)



// WEBPACK FOOTER //
// ./app/components/gear/modals/camera_selection_form.js